<div class="PageContent">

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProductQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteProductQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;DeleteIndustryProductStockOffer();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowExportStockQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowExportStockQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ExportStockQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">

      <mat-slide-toggle style="margin-bottom: 25px;" matTooltip="{{ 'ExportOnlyUIDataDescription' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.ExportOnlyUIData">{{'ExportOnlyUIData' | translate}}</mat-slide-toggle>
      <mat-slide-toggle style="margin-bottom: 25px;" matTooltip="{{ 'CombineWarehousesQuantityOnExportDescription' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.CombineWarehousesQuantityOnExport">{{'CombineWarehousesQuantityOnExport' | translate}}</mat-slide-toggle>

      <mat-form-field appearance="outline" class="ProductPropertyTextBox">
      <mat-label>{{ 'ExportIndustryProductsStockValuesType' | translate }}</mat-label>
      <mat-select name="ExportIndustryProductsStockValuesType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ExportIndustryProductsStockValuesType">
        <mat-option *ngFor="let t of this.ExportIndustryProductsStockValuesTypes" [value]="t">
          {{t.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="ProductPropertyTextBox">
      <mat-label>{{ 'ExportLanguage' | translate }}</mat-label>
      <mat-select name="ExportLanguage" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ExportLanguage">
        <mat-option *ngFor="let l of this.Languages" [value]="l">
          {{l.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowExportStockQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" style="background: #0082e6;" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowExportStockQuestion = false; ExportIndustryProductsStockValues();">{{ 'ExportStocks' | translate }}</button>
    </div>
  </div>

  <div class="NewProductContainer animated fadeInDown" *ngIf="ShowNewStockEntryContainer == true;">
    <div class="NewProductContainerTitleBar">
      <p *ngIf="this.NewProduct.ID == 0;">{{'AddStockEntry' | translate}}</p>
      <p *ngIf="this.NewProduct.ID > 0;">{{'UpdateStockEntry' | translate}}: {{this.NewProduct.Brand.Name}} {{this.NewProduct.Name}}</p>
      <i class="material-icons" (click)="ShowNewStockEntryContainer = false;">close</i>
    </div>
    <div class="NewProductContainerBody">
      <div class="TwoThirdsColumn">

        <div class="ColumnTitle">
          <i class="material-icons">radio_button_checked</i>
          {{'GeneralInformation' | translate}}
        </div>

        <div class="TitleSearchInputContainer SearchProductPop">
          <input type="text" class="TitleSearchInput" placeholder="{{'SearchProducts' | translate}}" autocomplete="off" (click)="InitializeSearchProduct();" [(ngModel)]="this.SearchTerm" matInput (ngModelChange)="this.productSearchTermUpdate.next($event)">
          <i class="material-icons TitleSearchInputContainerSearchIcon">search</i>
          <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.SearchTerm?.length > 0;" (click)="ClearSearchIndustryProducts();">close</i>
        
          <div class="TitleSearchInputResultsContainer" *ngIf="this.SearchedProducts?.length > 0">
            <div class="TitleSearchInputResult" *ngFor="let p of this.SearchedProducts" (click)="GetIndustryProductByID(p.ProductID, true);">
              <div class="TitleSearchInputResultTitle">
                {{p.FKBrandName}} {{p.ProductName}}
              </div>
              <div class="TitleSearchInputResultDate">
                {{p.ProductPartNumber}}
              </div>
            </div>
          </div>
        </div>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
          <mat-label>{{ 'Name' | translate }}*</mat-label>
          <input disabled="true" matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
          <mat-label>{{ 'PartNumber' | translate }}</mat-label>
          <input disabled="true" matInput placeholder="{{ 'PartNumber' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.PartNumber">
        </mat-form-field>

        <mat-form-field class="BrandSelectContainer" appearance="outline">
          <mat-label>{{'SelectBrand' | translate}}*</mat-label>
          <input disabled="true" class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto1"
                 [(ngModel)]="this.NewProduct.Brand.Name"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.NewProduct.Brand?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.NewProduct.Brand = brand;">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

      </div>

      <div class="OneThirdColumn">
      </div>

      <div class="ProductDelimiter"></div>

      <div class="TwoThirdsColumn">
        <div class="ColumnTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <mat-form-field class="BrandSelectContainer" appearance="outline" matTooltip="{{ 'ConfigurationWarehouseDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
          <mat-label>{{'SelectWarehouse' | translate}}</mat-label>
          <input id="warehouseselectid" class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectWarehouse' | translate}}"
                 matInput
                 [matAutocomplete]="auto4"
                 [(ngModel)]="this.ConfigurationWarehouseName"
                 (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                 (click)="InitializeWarehouses();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Warehouse?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto4="matAutocomplete">
            <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Configuration.Warehouse = warehouse; this.ConfigurationWarehouseName = warehouse.Name; GetImportConfigurationByWarehouse(warehouse.ID);">
              {{warehouse.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'LeadTimeType' | translate }}</mat-label>
            <mat-select [disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Type != null" name="LeadTimeType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.Warehouse.StockLeadTime.Type">
              <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                {{t.Name}}
              </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="BrandSelectContainer" *ngIf="this.Configuration.Warehouse.StockLeadTime != null">
          <mat-label>{{'Units' | translate}}</mat-label>
          <input [disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Units != null" matInput placeholder="{{'Units' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Configuration.Warehouse.StockLeadTime.Units">
        </mat-form-field>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
          <mat-label>{{ 'ProductConditionStatus' | translate }}</mat-label>
          <mat-select name="ConditionStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ListPriceOffer.ConditionStatus">
            <mat-option *ngFor="let s of this.ProductConditionStatuses" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
          <mat-label>{{ 'ProductBoxStatus' | translate }}</mat-label>
          <mat-select name="ConditionStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ListPriceOffer.BoxStatus">
            <mat-option *ngFor="let s of this.ProductBoxStatuses" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="OneThirdColumn">

        <div class="ColumnTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <mat-form-field appearance="outline" class="BrandSelectContainer">
          <mat-label>{{'ListPrice' | translate}}</mat-label>
          <input matInput placeholder="{{'ListPrice' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ListPriceOffer.ListPrice">
        </mat-form-field>

        <mat-form-field appearance="outline" class="BrandSelectContainer">
          <mat-label>{{'DiscountedPrice' | translate}}</mat-label>
          <input matInput placeholder="{{'DiscountedPrice' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ListPriceOffer.DiscountedPrice">
        </mat-form-field>

        <mat-form-field appearance="outline" class="BrandSelectContainer">
          <mat-label>{{'StockQuantity' | translate}}</mat-label>
          <input matInput placeholder="{{'StockQuantity' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ListPriceOffer.StockQuantity">
        </mat-form-field>

        <mat-form-field appearance="outline" class="ProductPropertyTextBox">
          <mat-label>{{ 'Currency' | translate }}</mat-label>
          <mat-select name="Currency" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ListPriceOffer.Currency">
            <mat-option *ngFor="let c of this.Currencies" [value]="c">
              {{c.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="BrandSelectContainer">
          <mat-label>{{'MOQ' | translate}}</mat-label>
          <input matInput placeholder="{{'MOQ' | translate}}" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ListPriceOffer.MOQ">
        </mat-form-field>

      </div>
    </div>
    <div class="NewProductContainerCommands">
      <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.ListPriceOffer.ID == 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">add</i>
        {{'AddStockEntry' | translate}}
      </button>

      <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.ListPriceOffer.ID > 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">edit</i>
        {{'UpdateStockEntry' | translate}}
      </button>
    </div>
  </div>

  <div class="overlayTransparent animated fadeIn" *ngIf="ShowFilter == true;" (click)="CloseOverlay();"></div>
  <div class="overlay animated fadeIn" *ngIf="ShowNewStockEntryContainer || ShowDeleteProductQuestion || ShowExportStockQuestion" (click)="CloseDashMenu();" style="z-index: 202;"></div>

  <div class="PageContentTitle">
      <div class="PageContentTitleIntro">
          <i class="material-icons">account_tree</i>
          <p class="PageContentTitleParagraph">{{'StockProducts' | translate}}</p>
      </div>

      <div class="TitleSearchInputContainer">
          <input type="text" class="TitleSearchInput" placeholder="{{'SearchStockProducts' | translate}}" autocomplete="off" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
          <i class="material-icons TitleSearchInputContainerSearchIcon">search</i>
          <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.Filter.SearchTerm?.length > 0;" (click)="this.Filter.SearchTerm = ''; this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">close</i>
      </div>

      <div class="PageContentTitleCommands">
          <button mat-raised-button color="primary" class="TitleFilterButton" (click)="ShowFilter = !ShowFilter;">
              {{'Filter' | translate}}
              <i class="material-icons">filter_alt</i>
              <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
          </button>

          <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="InitializeNewStockEntry();">
              {{'NewStock' | translate}}
              <i class="material-icons">add</i>
          </button>

          <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="ShowExportStockQuestion = true;">
            {{'ExportStocks' | translate}}
            <i class="material-icons">downloading</i>
          </button>

          <div class="ButtonFilterContainer animated fadeIn" *ngIf="ShowFilter == true;">
              <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
              <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>
              
              <div *ngIf="this.FilterLoading != true;">
                  <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductBoxStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductBoxStatus">
                            <mat-option *ngFor="let s of this.ProductBoxStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductBoxStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductConditionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductConditionStatus">
                            <mat-option *ngFor="let s of this.ProductConditionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductConditionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductManufacturingStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductManufacturingStatus">
                            <mat-option *ngFor="let s of this.ProductManufacturingStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductManufacturingStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductVersionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductVersionStatus">
                            <mat-option *ngFor="let s of this.ProductVersionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductVersionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                    <div class="ButtonFilterContainerOneThirdColumn">
                    
                    </div>
                    <div class="ButtonFilterContainerTwoThirdsColumn">
                    
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                    <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                      {{a.Name}}
                      <i class="material-icons ActiveFilterIcon">close</i>
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                      <div class="ButtonFilterContainerOneThirdColumn">
                          <button mat-raised-button color="primary" class="ApplyFilterButton" (click)="ShowFilter = false;GetIndustryProductsStocksFiltered();">
                              <i class="material-icons">check</i>
                              {{'ApplyFilter' | translate}}
                          </button>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">

                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

    <div class="PageContentBody animated fadeIn">
      <div class="PageContentBodyTopCommands">
         
        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectWarehouse' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectWarehouse' | translate}}"
                 matInput
                 [matAutocomplete]="auto1"
                 [(ngModel)]="this.FilterWarehouseName"
                 (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                 (click)="InitializeWarehouses();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Warehouse?.Name?.length > 0;" (click)="ClearSearchWarehouse();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Warehouse?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let wh of Warehouses" [value]="wh" (click)="this.Filter.Warehouse = wh; this.FilterWarehouseName = this.Filter.Warehouse.Name; this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">
              {{wh.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectBrand' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto2"
                 [(ngModel)]="this.FilterBrandName"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Brand?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand; this.FilterBrandName = this.Filter.Brand.Name; this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

            <div class="TopLevelPaginator unSelectable">
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);">
                <i class="material-icons">chevron_left</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
              </div>

              <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
                <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">
              </mat-form-field>

              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);">
                <i class="material-icons">chevron_right</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
              </div>

              <span class="pageInfoSpan">{{this.StockProducts?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'StockProducts' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
            </div>

            <button mat-raised-button color="primary" class="FilterResultsButton" (click)="GetIndustryProductsStocksFiltered();">
              <i class="material-icons">check</i>
              {{'ApplyFilter' | translate}}
          </button>
      </div>

      <div class="PageContentBodyElementsContainer">
        <div class="TaskRow TaskHeadderRow">
          <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
            #
          </div>
          <div class="ProductsCol" style="width: 25%;">
            {{'Name' | translate}}
          </div>
          <div class="ProductsCol" style="width: 20%;">
            {{'Properties' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;">
            {{'Brand' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;">
            {{'Warehouse' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;text-align:center;">
            {{'Quantity' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;text-align:center;">
            {{'LeadTime' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;text-align:center;">
            {{'Actions' | translate}}
          </div>
        </div>

        <div class="ProductsContainer">
          <div class="ProductRow" *ngFor="let p of this.StockProducts; let i=index;" [ngClass]="{'OverduePopUp': p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0 }">
            <div class="ProductsColWarnBubble" *ngIf="p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0;">
            </div>
            <div style="background: #32aa3a;" class="ProductsColWarnBubble" *ngIf="!(p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0);">
            </div>
            <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
              {{i + 1}}
            </div>
            <div class="ProductsCol" style="width: 25%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Brand != null;">
                {{p.Brand?.Name}}
              </p>
              <p class="ProductsColMain">
                <span style="font-size:15px;color: #0082e6;font-weight: 400;">{{p.Name}}</span>
              </p>
              <p class="ProductsColMain" *ngIf="p.PartNumber != null;">
                <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                {{p.PartNumber}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 20%;padding-top: 18px;">
              <p class="ProductsColMain" *ngIf="p.Stats?.HSCode != null;">
                <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                {{p.Stats?.HSCode}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.COO != null;">
                <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                {{p.Stats?.COO?.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.EAN != null;">
                <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                {{p.Stats?.EAN}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.Weight != null;">
                <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}
              </p>
              <p class="ProductsColMain">
                <span class="ProductsColMainSpan">{{'ProductManufacturingStatus' | translate}}: </span>
                {{p.ManufacturingStatus?.Name}}
              </p>
              <p class="ProductsColMain">
                <span class="ProductsColMainSpan">{{'ProductVersionStatus' | translate}}: </span>
                {{p.VersionStatus?.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 10%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Brand != null;">
                {{p.Brand?.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.ConditionStatus != null;">
                {{p.ListPriceOffers[0]?.ConditionStatus.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.BoxStatus != null;">
                {{p.ListPriceOffers[0]?.BoxStatus.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{p.ListPriceOffers[0]?.Configuration?.Warehouse?.Name}}
            </div>
            <div class="ProductsCol" style="width: 10%;text-align:center;">
              <span class="StockQuantitySpan" [ngClass]="{'alertStock': p.ListPriceOffers[0]?.StockQuantity < 3, 'lowStock': p.ListPriceOffers[0]?.StockQuantity >= 3 && p.ListPriceOffers[0]?.StockQuantity <= 5, 'normalStock': p.ListPriceOffers[0]?.StockQuantity > 5 && p.ListPriceOffers[0]?.StockQuantity <= 15, 'bigStock': p.ListPriceOffers[0]?.StockQuantity > 15 }">{{p.ListPriceOffers[0]?.StockQuantity}}</span>
            </div>
            <div class="ProductsCol" style="width: 10%;text-align:center;">
              {{p.ListPriceOffers[0]?.LeadTime?.Units}} {{p.ListPriceOffers[0]?.LeadTime?.Type?.Name}}
            </div>
            <div class="ProductsCol" style="width: 10%;text-align: center;padding-top: 10px;">
              <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
              <mat-menu #menu="matMenu">
               <button mat-menu-item class="ReceptionMenuButton" (click)="InitializeNewStockEntry(p);">
                   <i class="material-icons">edit</i>
                   <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
               </button>

               <button mat-menu-item class="ReceptionMenuButton" (click)="InitializeNewStockEntry(p, true);">
                <i class="material-icons">content_copy</i>
                <span>{{ 'CopyStockEntry' | translate }}</span>
               </button>

               <button mat-menu-item class="ReceptionMenuButton" (click)="ShowDeleteProductQuestion = true; PrepareDeleteListPriceOffer(p);">
                 <i class="material-icons">close</i>
                 <span>{{ 'Delete' | translate }}</span>
               </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
   
</div>